import { createContext } from 'react'

const FilterBarContext = createContext()

export default FilterBarContext
